<template>
  <div class="">
    <v-header ref="dudu"></v-header>
    <div class="beijngsd">
      <span></span>
      个人中心
      <span></span>
    </div>
    <div class="manpin">
      <div class="main centen container">
        <leftmenu></leftmenu>
        <div class="main_r">
          <div class="mainr_top">
            <img src="../../assets/gerenzhongxin/geren16.png">
            基本资料
          </div>
          <!-- pc填充说明 -->
          <div class="mainr_bot">
            <div class="youxinxi">
              <label>填写说明</label>
              <figure>
                <img src="../../assets/gerenzhongxin/geren1.png">
                <figcaption>基本信息中的省、市、县区、学校等信息选择后不可更改，请用户谨慎选择</figcaption>
              </figure>

            </div>
          </div>
          <ul class="form">
            <li>
              <label>用户名</label>
              <i>*</i>
              <input v-model="userInfo.loginName" disabled />
            </li>
            <li>
              <label>姓名</label>
              <i>*</i>
              <input v-model="userName" @focus="userNameflag = false" @blur="getrp()" />
              <span class="shangxia" v-if="userNameflag">请输入您的姓名</span>
            </li>
            <li>
              <label>性别</label>
              <i>*</i>
              <el-radio v-model="userSex" :label="1">男</el-radio>
              <el-radio v-model="userSex" :label="0">女</el-radio>
            </li>
            <!-- <li v-if="!$utils.showflag(userInfo.userPhone)">
              <label>手机号</label>
              <i>*</i>
              <div class="shoujiinp"  v-if="!$utils.showflag(userInfo.userPhone)">
                <input type="" v-model="userPhone" maxlength="11" @input="getphone()" @focus="userPhoneflag = false" @blur="getphonerp()" />
                <button @click="sendMsg" type="primary" :class="[dusnhhwe == true ? 'duanxin':'duanxin2']"
                  :disabled="isDisabled" v-html="buttonName"></button>
                <span class="shangxia" v-show="userPhoneflag">{{userPhonemessage}}</span>
              </div>
            </li>
            <li v-if="!$utils.showflag(userInfo.userPhone)">
              <label>验证码</label>
              <i>*</i>
              <div class="shoujiinp">
                <input v-model="code" @focus="codeflag = false" />
                <span class="shangxia" v-if="codeflag">请输入验证码</span>
              </div>
            </li> -->
            <li>
              <label>所在省份</label>
              <i>*</i>
              <el-select v-model="userProvinces" class="inps" placeholder="请选择" @focus="userProvincesflag = false"
                @change="changelist(0,$event)" :disabled="$utils.showflag(userInfo.userProvinces)&&!updateflag">
                <el-option v-for="(item,index) in areaList" :key="item.value" :label="item.text" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-model="userCities" class="inps" placeholder="请选择" @change="changelist(1,$event)"
                :disabled="$utils.showflag(userInfo.userCities)&&!updateflag">
                <el-option v-for="(item,$event) in CitiesList" :key="item.value" :label="item.text" :value="item.text">
                </el-option>
              </el-select>
              <el-select v-model="userCounties" class="inps" placeholder="请选择"
                :disabled="$utils.showflag(userInfo.userCounties)&&!updateflag" @change="changelist(2,$event)">
                <el-option v-for="(item,index) in CountiesList" :key="item.value" :label="item.text" :value="item.text">
                </el-option>
              </el-select>
              <span class="shangxia" v-if="userProvincesflag">请选择所在地信息</span>
            </li>
            <li>
              <label>就读中学</label>
              <i>*</i>
              <el-select v-model="userSchool" class="inpda" placeholder="请选择" @focus="userSchoolflag = false"
                :disabled="$utils.showflag(userInfo.userSchool)&&!updateflag">
                <el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.name">
                </el-option>
                <el-option label="其他  (未找到就读中学时选择此项)" value="其他"></el-option>
              </el-select>
              <span class="shangxia" v-if="userSchoolflag">请选择就读高中</span>
            </li>
            <li>
              <label>班级</label>
              <i style="color: #FFFFFF">*</i>
              <input v-model="userEmail" />
            </li>
            <button type="button" class="baochuan" @click="save">保存</button>
          </ul>
          <!-- 手机端填充说明 -->
          <div class="mainr_bot2">
            <div class="youxinxi2">
              <label>填写说明</label>
              <figure>
                <img src="../../assets/gerenzhongxin/geren1.png">
                <figcaption>请按照既定格式填写，切勿更改</figcaption>
              </figure>
              <figure>
                <img src="../../assets/gerenzhongxin/geren2.png">
                <figcaption>相关项目如无内容，只需填“无”即可，切勿将条目删除</figcaption>
              </figure>
              <figure>
                <img src="../../assets/gerenzhongxin/geren3.png">
                <figcaption>教育经历中“专业”和“学历”必填</figcaption>
              </figure>
              <figure>
                <img src="../../assets/gerenzhongxin/geren4.png">
                <figcaption>工作经历中，工隹内容请逐条详细列出。 如果在同一公司不同时期有不同任职的</figcaption>
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>

    <item7></item7>
    <toast title="保存成功" message="用户信息保存成功" @close="toastflag = false" :flag="toastflag" v-if="toastflag" btn=""></toast>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import leftmenu from '../../components/leftmenu.vue'
  import city from '../../assets/city.js'
  import toast from '../../components/toast.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      leftmenu,
      toast
    },
    data() {
      return {
        buttonName: "发送短信",
        isDisabled: true,
        time: 60,
        options: [],
        dusnhhwe: true,
        shoujihao: "",
        yanshouji: false,
        userInfo: {},
        userName: "",
        userPhone: "",
        code: '',
        userProvinces: "",
        userSchool: "",

        userNameflag: false,
        userPhoneflag: false,
        userPhonemessage: '请输入正确的手机号',
        codeflag: false,
        userSchoolflag: false,
        userProvincesflag: false,
        role:0,
        updateflag:false,

        userCities: "",
        userCounties: "",
        userEmail: "",
        userSex: 1,

        areaList: [],
        CitiesList: [],
        CountiesList: [],
        schoolList: [],
        interval: null,
        title: "",
        message: "",
        toastflag: false,
      }
    },

    methods: {
      changelist(n, index) {
        let _this = this;
        if (n == 0) {
          this.areaList.forEach(function(item) {
            if (item.value + '' == index) {
              _this.$req.selectOne('area', {id:item.value}).then(function(response) {
                console.log(response.data.disTime)
                _this.$utils.setlocalStorage('disTime',response.data.disTime)
              })
              _this.CitiesList = item.children
            }
          })
        } else if (n == 1) {
          this.CitiesList.forEach(function(item) {
            if (item.text == index) {
              _this.CountiesList = item.children
            }
          })
        } else if (n == 2) {
          console.log("获取学校")
          _this.$req.queryAllByLimit('heighschool', {
            pageSize: 0,
            pageNum: 0,
            queryObj: {
              area: _this.userProvinces,
              city: _this.userCities,
              county: _this.userCounties
            }
          }).then(function(response) {
            _this.schoolList = response.data
          })
        }
      },
      // 取消退出
      getphone() {
        this.isDisabled = true;
        console.log(this.userPhone)
        if (this.userPhone.length == 11) {
          this.getphonerp();
        }
      },
      getphonerp() {
        let _this = this;
        if (!/^1[3456789]\d{9}$/.test(this.userPhone)) {
          this.userPhoneflag = true;
          return false
        } else {
          this.$req.queryphone({
            phone: this.userPhone
          }).then(function(resp) {
            console.log(resp)
            if (resp.data == '0') {
              // _this.code = resp.str
              _this.isDisabled = false;
              _this.userPhoneflag = false;
            } else {
              _this.userPhonemessage = resp.message
              _this.userPhoneflag = true;
            }
          })
        }
      },
      sendMsg() {
        // 手机号验证
        if (!/^1[3456789]\d{9}$/.test(this.userPhone)) {
          this.userPhonemessage = "请输入正确的手机号"
          this.userPhoneflag = true
          return false;
        } else {
          this.userPhoneflag = false
          let me = this;
          me.dusnhhwe = false
          me.isDisabled = true;
          // me.time = 2 ;
          this.sendCode()
          me.buttonName = '<a class="biaoshu">' + 60 + 's</a>' + '<span>后发送</span>';
          this.interval = window.setInterval(function() {
            me.buttonName = '<a class="biaoshu">' + me.time + 's</a>' + '<span>后发送</span>';
            --me.time;
            if (me.time < 0) {
              me.buttonName = "重新发送";
              me.dusnhhwe = true
              me.time = 59;
              me.isDisabled = false;
              window.clearInterval(me.interval);
            }
          }, 1000);
        }
      },
      sendCode() {
        let _this = this;
        _this.$req.sendonewphonecode({
          phone: this.userPhone
        }).then(function(resp) {
          console.log(resp)
          if (resp.data == '0') {
            _this.code = resp.str
          } else {
            _this.userPhonemessage = resp.message
            _this.userPhoneflag = true;
            _this.buttonName = "重新发送";
            _this.dusnhhwe = true
            _this.time = 59;
            _this.isDisabled = false;
            window.clearInterval(_this.interval);
          }
        })
      },

      getrp() {
        let _this = this;
        let namerp = /(^[\u4e00-\u9fa5]{1}[\u4e00-\u9fa5\.·。]{0,18}[\u4e00-\u9fa5]{1}$)|(^[a-zA-Z]{1}[a-zA-Z\s]{0,18}[a-zA-Z]{1}$)/;

        if (!this.$utils.showflag(this.userName)) {
          this.userNameflag = true;
          return false
        }
        // if(!this.$utils.showflag(this.userInfo.userPhone)){
        //   if (!/^1[3456789]\d{9}$/.test(this.userPhone)) {
        //     this.userPhonemessage = "请输入正确的手机号"
        //     this.userPhoneflag = true
        //     return false;
        //   }
        //   if (this.code == null || this.code == '') {
        //     this.codeflag = true;
        //     return false
        //   }
        // }
        if (!this.$utils.showflag(this.userInfo.userProvinces)) {
          if (this.userProvinces == null || this.userCities == '' || this.userCounties == '') {
            this.userProvincesflag = true;
            return false
          }
        }
        if (!this.$utils.showflag(this.userInfo.userSchool)) {
          if (this.userSchool == null || this.userSchool == '') {
            this.userSchoolflag = true;
            return false
          }
        }


        if (this.userNameflag || this.userPhoneflag || this.codeflag || this.userProvincesflag || this.userSchoolflag) {
          return false
        } else {
          return true
        }
      },
      save() {
        let _this = this;
        if (this.getrp()) {
          let obj = {
            userName: this.userName,
            userSex: parseInt(this.userSex),
            userId: this.userInfo.userId,
            userEmail: this.userEmail
          }
          if (!this.$utils.showflag(this.userInfo.userProvinces)||this.updateflag) {
            obj.userProvinces = this.userProvinces
            obj.userCities = this.userCities
            obj.userCounties = this.userCounties
          }
          if (!this.$utils.showflag(this.userInfo.userSchool)) {
            obj.userSchool = this.userSchool
          }
          if (!this.$WebName) {
            this.userInfo.userProvinces = '130000'
            obj.userProvinces = '130000'
          }

          _this.$req.update('userTable', obj).then(function(response) {
            _this.toastflag = true
            _this.userInfo.userName = _this.userName
            _this.userInfo.userSex = _this.userSex
            _this.userInfo.userEmail = _this.userEmail
            if (!_this.$utils.showflag(_this.userInfo.userProvinces)||_this.updateflag) {
              _this.userInfo.userProvinces = _this.userProvinces
              _this.userInfo.userCities = _this.userCities
              _this.userInfo.userCounties = _this.userCounties
            }
            if (!_this.$utils.showflag(_this.userInfo.userSchool)) {
              _this.userInfo.userSchool = _this.userSchool
            }
            if (!_this.$WebName) {
              _this.userInfo.userProvinces = '130000'
            }
            _this.$utils.setlocalStorage('userInfo', _this.userInfo)
            let xuankeArea = _this.$utils.getlocalStorage('xuankeArea')
            let area = _this.$utils.getlocalStorage('AREA_OBJ')[parseInt(_this.userInfo.userProvinces)]
            if (xuankeArea.xingaokao.indexOf(area) == -1) {
              _this.$utils.setlocalStorage('tianbaoType', 0) //老高考
            } else if (xuankeArea.xingaokao2.indexOf(area) != -1 || xuankeArea.xingaokao3.indexOf(area) != -1) {
              _this.$utils.setlocalStorage('tianbaoType', 2) //专业组
            } else {
              _this.$utils.setlocalStorage('tianbaoType', 1) //单专业
            }
            _this.$utils.setlocalStorage('areaInfo', {
              areaId: parseInt(_this.userInfo.userProvinces),
              areaName: area,
              areaFullName: _this.$utils.getAreaFullName(_this.userInfo.userProvinces)
            })
            if (!_this.$utils.setlocalStorage('scoreInfo')) {
              _this.$router.push('/grzx_wdfs')
            }
          })
        }
      }

    },
    created() {
      console.log('gerenzhongxin')
      let _this = this;
      this.areaList = city.area
      this.userInfo = this.$utils.getlocalStorage("userInfo")

      this.userName = this.userInfo.userName
      this.userSex = this.userInfo.userSex
      if (this.userSex == null) {
        this.userSex = 1
      }
      this.userPhone = this.userInfo.userPhone
      if (!this.$WebName) {
        this.userInfo.userProvinces = '130000'
        this.areaList.forEach(function(item) {
          if (item.value + '' == '130000') {
            _this.CitiesList = item.children
          }
        })
      }
      if(this.userInfo.userProvinces!=null&&this.userInfo.userCities==null){
        this.areaList.forEach(function(item) {
          if (item.value + '' == _this.userInfo.userProvinces) {
            _this.CitiesList = item.children
          }
        })
      }


      this.role = this.userInfo.userRole
      if(parseInt(this.role)==3){
        this.updateflag = true;
      }
      this.userProvinces = this.userInfo.userProvinces
      this.userCities = this.userInfo.userCities
      this.userCounties = this.userInfo.userCounties
      this.userSchool = this.userInfo.userSchool
      this.userEmail = this.userInfo.userEmail


    }


  }
</script>

<style scoped>
  /* 退出登录 */
  .tuichuden {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
  }

  .annou {
    display: flex;
    flex-direction: column;
    width: 380px;
    height: 229px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 20px;
    padding: 0 21px;
    box-sizing: border-box;
  }

  .annou h1 {
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    opacity: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .annou p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    flex: 1;
  }

  .annou dl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .annou dl dt {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: rgba(200, 200, 200, 1);
    opacity: 1;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annou dl dd {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    box-shadow: 0px 0px 10px #F53824;
    opacity: 1;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }




  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    margin-top: 70px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding: 40px 0;
    box-sizing: border-box;
    background: #ebeef5d6;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
  }



  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .texts {
    color: #F53824 !important;
  }



  .main_r {
    width: 1050px;
    height: 905px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 300px;
    height: 200px;
    background: rgba(253, 251, 247, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: 24px;
    right: 200px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }

  .form {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    margin-left: 40px;
  }

  .form li {
    width: auto;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
  }

  .form li label {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 80px;
    text-align: right;
  }

  .form li i {
    color: #F53824;
    margin: 0 5px;
  }

  .form li input {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E0E0E0;
    opacity: 1;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;

  }

  .duanxin {
    border: none;
    position: absolute;
    top: 5px;
    left: 240px;
    width: 120px;
    height: 30px;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .duanxin2 {
    border: none;
    position: absolute;
    top: 5px;
    left: 240px;
    width: 120px;
    height: 30px;
    background: rgba(238, 238, 238, 1);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }

  .shoujiinp {
    width: auto;
    display: flex;
    position: relative;
  }

  .form li {
    position: static;
  }

  /* .form li .shoujiinp input{width: auto;} */
  .form li .shoujiinp span {
    display: flex;
    align-items: center;
  }

  .form li span {
    margin-left: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    opacity: 1;
  }

  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }

  .baochuan {
    border: none;
    margin-left: 115px;
    margin-top: 20px;
    width: 140px;
    height: 46px;
    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }



  @media (min-width:750px) {
    .mainr_bot2 {
      display: none;
    }
  }

  @media (max-width:750px) {

    /* 退出登录 */
    .annou {
      width: 85%;
    }

    .annou dl dt {
      width: 110px;
      height: 45px;
    }

    .annou dl dd {
      width: 110px;
      height: 45px;
    }

    .mainr_bot {
      display: none;
    }

    .beijngsd {
      height: 70px;
      font-size: 24px;
    }

    .main {
      flex-direction: column;
    }

    .main_l {
      width: 100%;
    }

    .jibenxinxi::-webkit-scrollbar {
      display: none;
    }

    .manpin {
      padding: 20px 0;
    }

    .topxiang {
      flex-direction: row;
      width: 100%;
      height: auto;
      justify-content: revert;
      margin-bottom: 15px;
    }

    .topxiang span {
      margin-left: 20px;
    }

    .topxiang img {
      margin: 0;
      height: 60px;
      width: 60px;
    }

    .jibenxinxi {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      overflow-y: hidden;
      overflow: auto;
      background: whitesmoke;
    }

    .jibenxinxi figure {
      flex-shrink: 0;
      width: auto;
      margin: 0 5px;
    }

    .beijngsdtu {
      /* background: url(../../assets/gerenzhongxin/sj_geren26.png)no-repeat; */
      background: none;
      /* background-size: 100% 100%; */
      border-bottom: 1px solid #F53824;
    }

    .jibenxinxi figure img {
      margin-left: 0;
    }

    .youxinxi2 {
      padding: 33px 20px 0 20px;
      width: 100%;
      height: 230px;
      background: rgba(253, 251, 247, 1);
      border: 1px solid #FBF5E9;
      opacity: 1;
      border-radius: 5px;
      position: relative;
    }

    .mainr_bot2 {
      width: 100%;
      margin-top: 20px;
      /* position: relative; */
    }

    .youxinxi2 label {
      position: absolute;
      top: -14px;
      left: 20px;
      width: 92px;
      height: 28px;
      background: rgba(244, 166, 65, 1);
      opacity: 1;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    .youxinxi2 figure {
      display: flex;
      margin-bottom: 13px;
    }

    .youxinxi2 figure img {
      margin-right: 4px;
      width: 18px;
      height: 20px;
    }

    .youxinxi2 figure figcaption {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #5A4F40;
    }

    .main_r {
      width: 100%;
      display: flex;
      flex-direction: column;
    }


    .form {
      margin-left: 0;
    }

    .shoujiinp {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .form li {
      position: static;
    }

    .form li .shoujiinp input {
      width: auto;
    }

    .form li .shoujiinp span {
      margin-top: 5px;
    }

    .form li label {
      flex-shrink: 0;
    }

    .duanxin {
      right: 10px;
      left: auto;
      top: 5px;
      width: 85px;
      border-radius: 5px;
      font-size: 10px;
    }

    .duanxin2 {
      right: 10px;
      left: auto;
      top: 5px;
      width: 85px;
      border-radius: 5px;
      font-size: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/a_userinfo.vue